import * as React from "react";
import { forwardRef, memo } from "react";
const SvgExpandLess = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M266.174-371.413Q252.5-385.087 252.5-404.739t13.674-33.326l180-180q7.717-7.718 16.293-11.196T480-632.739t17.533 3.478 16.293 11.196l181 181q13.674 13.674 14.055 32.445.38 18.772-14.055 33.207-13.674 13.674-33.326 13.674t-33.326-13.674L480-518.587 331.826-370.413q-13.674 13.674-32.446 13.554t-33.206-14.554" })));
const ForwardRef = forwardRef(SvgExpandLess);
const Memo = memo(ForwardRef);
export default Memo;
